import { inject, Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { UserApi, userApiSchema } from '@shared/services/users';
import { UserStore } from '@stores/user-store';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { z } from 'zod';

@Injectable({
  providedIn: 'root',
})
export class UsersData extends ApiServiceBase<UserApi> {
  private readonly userStore = inject(UserStore);

  constructor() {
    super('users');
  }

  fetchUserAccount(): Observable<UserApi> {
    return this.read('me').pipe(
      tap((user) => {
        const userValidated = userApiSchema.safeParse(user);
        if (userValidated.success) {
          this.userStore.set(userValidated.data);
        } else {
          this.logs.error('initializeUserData', 'Invalid user data:', z.flattenError(userValidated.error));
        }
      }),
      catchError((error: Error) => {
        this.logs.error('initializeUserData', 'Failed to fetch user data:', error);
        return throwError(() => error);
      })
    );
  }
}
